import React, { useEffect, useState } from 'react'
import { Button,  } from 'antd'
import AttTable from './attTable'
import MarkAttModal from './markAttModal'
import moment from 'moment'
import { postRequest } from '../../utils/APICall'
import DatePickerComponent from '../DatePicker'

const MarkAttendance = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchLoader, setSearchLoader] = useState(false);
  const showModal = () => setIsModalOpen(true);
  const [searchDate, setSearchDate] = useState("");
  const [attData, setAttData] = useState("");
  // const handleOk = () => setIsModalOpen(false);
  const handleClose = () => setIsModalOpen(false);
  const pickFromDate = (date, dateString) => {
    setSearchDate(dateString);
  };

  const searchAttendence = async () => {
    let obj = {
      vdept:null,
      vid: null,
      todate: searchDate,
      fromdate: searchDate,
    };
    try {
      setSearchLoader(true)
      const response = await postRequest("AttReport", obj);
      if(response.success){
        // console.log("search  get detail",response);
        setAttData(response?.data )
      } else{
        setAttData([])
      }
    } catch (error) {
      setSearchLoader(false)
      setAttData([])
      console.error("Error in API request:", error);
    } finally{
      setSearchLoader(false)
    }

  }
  // console.log("searchDate",searchDate)
  const yesterdayAtt = async () => {
    const cachedData = sessionStorage.getItem("previousDayAttendance");
    const yesterday = moment().subtract(1, "days").format("DD-MMMM-YYYY");
    const obj = {
     vdept:null,
      vid: null,
      todate: yesterday,
      fromdate: yesterday,
    };
  
    if (cachedData) {
      setAttData(JSON.parse(cachedData))
    }
    try {
      const response = await postRequest("AttReport", obj);
      setAttData(response?.data)
      sessionStorage.setItem("previousDayAttendance", JSON.stringify(response?.data));
    } catch (error) {
      console.error("Error in API request:", error);
    }
  };
  
  useEffect(() => {
    yesterdayAtt()
  }, [])
  return (
    <>
      <span className='flex  justify-start flex-wrap gap-4  px-4 py-4  w-full overflow-hidden'>
        <span className='w-full sm:w-fit  '>
          <DatePickerComponent
            onChange={pickFromDate}
            date={searchDate}
            customStyle={"w-full md:w-[352px] h-10 "}
            placeholder="Select Date ..."

            size='large' />
        </span>
        {/* <span className='flex gap-4 flex-wrap'> */}
        <Button color="primary" size="large" disabled={searchDate == ""|| searchLoader } className={searchDate !== "" ? ' text-lg font-bold text-gray-100 p-4  md:px-20' : " cursor-not-allowed text-lg font-bold text-gray-100 p-4  md:px-20 disabled:dark:text-white disabled:dark:bg-gray-500"} onClick={searchDate !== "" ? searchAttendence : null} variant="solid" >
          {searchLoader ? "Searching..." : "Search"}
          
        </Button>
        <Button onClick={showModal} color="primary" size="large" className='bg-[#6436cf]  hover:scale-105 text-lg font-bold text-gray-100 p-4  md:px-10' variant="solid">
          Mark Attendence
        </Button>
        {/* </span> */}
      </span>
      {/* <div className="flex flex-wrap items-center w-full justify-center">
  
  <div className="w-full md:w-1/3  text-center  flex flex-col gap-2 px-2">
    <span className="text-sm md:text-xl font-semibold">Annual Leaves</span>
    <span className="bg-gray-100 shadow-2xl p-2 border-2 rounded-xl font-black">12</span>
  </div>

  <div className="w-full md:w-1/3 text-center flex flex-col gap-2">
    <span className="text-sm md:text-xl font-semibold">Sick Leaves</span>
    <span className="bg-gray-100 shadow-2xl p-2 border-2 rounded-xl font-black">06</span>
  </div>

  <div className="w-full md:w-1/3 text-center flex flex-col gap-2  sm:mt-0">
    <span className="text-xl font-semibold text-white">.</span>
    <span className="text-sm md:text-sm bg-gray-100 shadow-2xl py-2 border-2 rounded-xl font-semibold">
      Leaves Can Be Availed After 06 Month Of Joining.
    </span>
  </div>
</div> */}
      <AttTable Data={attData}  />

      <MarkAttModal open={isModalOpen} onClose={handleClose} />
    </>
  )
}

export default MarkAttendance